import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';

import { SharedProgrammingService } from './../../../common/services/shared-programming.service';
import { ProgrammingUtilsService as Utils } from '../../../common/services/utils.service';


@Component({
  selector: 'prg-select-type',
  templateUrl: './select-type.component.html'
})
export class SelectTypeComponent implements OnInit {

  ready: Observable<boolean>;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private store: Store<any>,
    private shared: SharedProgrammingService

  ) {
    this.ready = this.shared.isReady;
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-buttons/select-type/select-type.component.ts